import { POST } from '@/api'
import { baseState } from '@/store/reservation'
import { omit } from 'lodash'
import { padZero } from '@/utils/number'
import { formatDate } from '@/utils/date'

export default {
  namespaced: true,
  state: {
    ...baseState,
  },
  mutations: {
    updateReservation(state, value) {
      state.reservation = Object.assign(state.reservation, value)
    },
    updateReservationId(state, value) {
      state.reservation.id = value
    },
    updateReservationYear(state, value) {
      state.reservation.reserveDate.year = value
    },
    updateReservationMonth(state, value) {
      state.reservation.reserveDate.month = value
    },
    updateReservationDay(state, value) {
      state.reservation.reserveDate.day = value
    },
    updateReservationWeekday(state, value) {
      state.reservation.reserveDate.weekday = value
    },
    updateReservationHour(state, value) {
      state.reservation.reserveDate.hour = value
    },
    updateReservationMinute(state, value) {
      state.reservation.reserveDate.minute = padZero(value)
    },
    updateReservationAdults(state, value) {
      state.reservation.adults = parseInt(value, 10)
    },
    updateReservationChildren(state, value) {
      state.reservation.children = parseInt(value, 10)
    },
    setCustomer(state, customer) {
      state.originCustomer = Object.assign(state.originCustomer, customer)
      state.customer = Object.assign(state.customer, customer)
    },
  },
  getters: {},
  actions: {
    updateReservationDate({ commit }, value) {
      commit('updateReservationYear', formatDate(value, 'YYYY'))
      commit('updateReservationMonth', formatDate(value, 'MM'))
      commit('updateReservationDay', formatDate(value, 'DD'))
      commit('updateReservationWeekday', formatDate(value, 'dd'))
    },
    updateReservationNumberOfPeople({ rootState }, { adults, children }) {
      rootState.reserveData.reservation.adults = parseInt(adults, 10)
      rootState.reserveData.reservation.children = parseInt(children, 10)
    },
    async getReservationDetail(store, reserveId = null) {
      const { commit, dispatch, rootState } = store

      const { status, message, data } = await POST('/api/web/reservation/detail', {
        reservationId: reserveId,
        alertType: rootState.app.alert_type || null,
      })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
        dispatch('updateReservationId', null)
      }

      const { customer, reservation } = data || {}
      if (!reservation) return false

      if (customer?.id) {
        const cust = await dispatch('customers/detail/get', { id: customer.id }, { root: true })
        if (cust) customer.visitCount = cust.visitCount // TODO 予約詳細APIから返してもらった方がよい
      }

      const { adults, children, tables, reserveTime, reserveDate } = reservation
      commit('setCustomer', customer)
      commit('updateReservation', {
        ...omit(reservation, ['reserveDate', 'reserveTime', 'tables']),
        adults,
        children,
        table: tables.map(table => table.id).join(','),
      })
      dispatch('updateReservationDate', reserveDate)
      const [hour, minute] = reserveTime.split('：')
      commit('updateReservationHour', hour)
      commit('updateReservationMinute', minute)

      return status === 200
    },
  },
}
